import type { Launch, Overview } from './api';
import { launchMetrics } from './metrics';
import type { VolumePeriod, VolumeValue } from './rolling-volume';
import type { ScreenerFields } from './premium';

export interface ScreenerValues {
  base: string; graduated: boolean; volume: number | null;
  marketCap: number | null; minedPercent: number | null; liquidity: number | null;
}
export function screenerVolumePeriod(fields: Pick<ScreenerFields, 'volume_period'>): VolumePeriod {
  return 'h1' in fields.volume_period ? '1h' : 'd7' in fields.volume_period ? '7d' : '24h';
}
function inRange(value: number | null, minimum: [] | [number], maximum: [] | [number]) {
  if (!minimum.length && !maximum.length) return true;
  return value !== null && Number.isFinite(value) && (minimum[0] === undefined || value >= minimum[0]) && (maximum[0] === undefined || value <= maximum[0]);
}
export function matchesScreenerValues(values: ScreenerValues, fields: ScreenerFields) {
  return (!fields.base.length || values.base === fields.base[0]!.toText()) &&
    ('all' in fields.phase || values.graduated === ('listed' in fields.phase)) &&
    inRange(values.volume, fields.min_volume_usd, fields.max_volume_usd) &&
    inRange(values.marketCap, fields.min_marketcap_usd, fields.max_marketcap_usd) &&
    inRange(values.minedPercent, fields.min_mined_percent, fields.max_mined_percent) &&
    inRange(values.liquidity, fields.min_liquidity_usd, fields.max_liquidity_usd);
}
export function filterScreenerLaunches(data: Overview, volumes: Map<string, VolumeValue | null> | undefined, fields: ScreenerFields): Launch[] {
  return data.launches.filter(launch => {
    const metrics = launchMetrics(data, launch);
    return matchesScreenerValues({ base: launch.base.toText(), graduated: launch.graduated, volume: volumes?.get(launch.market.toText())?.dollars ?? null,
      marketCap: metrics.marketCap, minedPercent: metrics.minedPercent, liquidity: metrics.liquidity }, fields);
  }).sort((first, second) => {
    const a = volumes?.get(first.market.toText())?.dollars ?? null, b = volumes?.get(second.market.toText())?.dollars ?? null;
    if (a === null || b === null) return a === b ? first.market.toText().localeCompare(second.market.toText()) : a === null ? 1 : -1;
    return b - a || first.market.toText().localeCompare(second.market.toText());
  });
}
